import { resolveFieldIssueMessage } from '@/composables/resolveFieldIssueMessage'
import type { TranslateFn } from '@/composables/TranslateFn'
import type { ApiFieldIssue } from '@/services/api/ApiFieldIssue'

/** The locale-backed message for a single `ApiFieldIssue` entry. */
export const fieldIssueMessage = (issue: ApiFieldIssue, t: TranslateFn): string =>
  resolveFieldIssueMessage(issue, t)
